// extracted by mini-css-extract-plugin
export default {"input":"LimiteFilter_input__j0UTh","label":"LimiteFilter_label__EKz0K"};